import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { LoadingService } from '../loading.service';
import { GlobalsService } from '../globals.service';
import {catchError, lastValueFrom, map, of, tap, throwError} from 'rxjs';
import { AdminService } from '../admin.service';
import { Reservation } from '@app/models/micro/reservation.model';
import { Passenger } from '@app/models/micro/passenger.model';
import moment from "moment";
import { LoyaltyMapper } from '@app/mappers/micro/loyalty.mapper';
import { TypeLoading } from '@app/enums';
import { CorporateInt } from '@app/interfaces/micro/loyalty.interface';
import {ErrorAdapter} from "@models/adapter/error.adapter";

/**
 * Servicio para realizar llamadas a la API de check-in,
 * getViewDocuments,
 * UpdateDocuments,
 * eligibility,
 * passengerlistupgrade,
 * passengerliststandby,
 * digital,
 * getFlightDetails,
 * getBoardingPass,
 */
@Injectable({
  providedIn: 'root'
})
export class LoyaltyService {

  urlApiMicro: string = `${environment.urlApiMicro}`;
  urlApiLoyal: string = `${environment.urlApiLoyal}`;
  constructor(
    private _loadingService: LoadingService,
    private _http: HttpClient,
    private _globalService: GlobalsService,
    private _admin: AdminService
  ) { }

  formatDate(date) {
    let response = moment(date).format("YYYY-MM-DD");
    return response
  }

  /**
   * Manejo de errores HTTP para las peticiones.
   * @param {HttpErrorResponse} error - Respuesta de error HTTP
   * @returns {Observable<never>} Observable con error procesado
   */
  handlerError(error: HttpErrorResponse) {
    this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
    const errorAdapter = ErrorAdapter.adapt(error.error);
    return throwError(errorAdapter);
  }

  /**
   * Obtiene beneficios de los pasajeros.
   *
   * @param {Reservation} reservation - Información de la reservación obtenida desde el sistema AWS.
   * @param {Passenger} passengers - Información de los pasajeros obtenida desde el sistema AWS.
   * @returns {Observable<ElegibilityRespInt>} - Un observable que emite la respuesta de elegibilidad del check-in.
   */

  getBenefits(reservation: Reservation) {
    const params = LoyaltyMapper.coreRequest(reservation);

    // If the payload is empty, return an observable with null to avoid calling the backend
    if (!params?.length) {
      return of([]);
    }

    this._loadingService.showLoading(TypeLoading.FULL_LOADING);
    return this._http.post(`${this.urlApiLoyal}${environment.versionBenefitsCore}/uc/benefitscore/vn`, params, {
      headers: {
        //'channel': 'KIOSK',
        'pos': 'KIOSK',
        'flow': 'KIOSK',
      }
    }).pipe(map(res => {
      this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
      return LoyaltyMapper.coreResponse(res)
    }), catchError(this.handlerError.bind(this)))
  }

  /**
   * FFN Association Microservice Contract
   *
   * @param {Reservation} reservation - Información de la reservación obtenida desde el sistema AWS.
   * @param {Passenger} passengers - Información de los pasajeros obtenida desde el sistema AWS.
   * @returns {Observable<ElegibilityRespInt>} - Un observable que emite la respuesta de elegibilidad del check-in.
   */
  getAssosiateFFN(passenger:Passenger, reservation: Reservation) {
    const body = LoyaltyMapper.requestAssosiateFFN(passenger,reservation)
    this._loadingService.showLoading(TypeLoading.FOOTER_LOADING);
    console.log("URL",this.urlApiLoyal+'/ub/ffnassociation')
    return this._http.post(`${this.urlApiLoyal}${environment.versionBenefitsCore}/ub/ffnassociation`, [body], {
      headers: {
        'channel': 'web',
        'pos':'web',
        'flow': 'checkin',

      }
    }).pipe(
      tap(response =>{console.log("Res - AssosiateFFN",response)}),
      map(res => {
      this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
      return res
    }),
        catchError(this.handlerError.bind(this)))
  }

   handlerErr(error: HttpErrorResponse, loading: TypeLoading = TypeLoading.FOOTER_LOADING) {
    this._loadingService.hideLoading(loading);
    const errorAdapter = ErrorAdapter.adapt(error.error);
    return throwError(errorAdapter);
  }

  getCorporate(reservation: Reservation) {
    const { flightSummary, clid } = reservation;
    const { currentSegment } = flightSummary;
    const corporateAccount = clid.replace('AM', '');
    const params = {
      bookingClass: currentSegment.bookingClass,
      corporateAccount,
      region: flightSummary.legRegion,
    }

    const headers = new HttpHeaders({
      'pos': 'kiosk',
      'flow': 'profile',
      'token': 'KIOSKOSAM',
    });
    this._loadingService.showLoading(TypeLoading.FULL_LOADING);
    return this._http.get<CorporateInt>(`${this.urlApiLoyal}${environment.versionBenefitsCoreCorporate}/uc/benefitscore/corporate`, { params,headers },).pipe(
      map(response =>  {
         this._loadingService.hideLoading(TypeLoading.FULL_LOADING);
         return LoyaltyMapper.corporateResponse(response)
      })
      ,catchError(err => this.handlerErr(err,TypeLoading.FULL_LOADING))
    )
  }
}
